import { render, staticRenderFns } from "./checklistCommentsModal.vue?vue&type=template&id=294a062f&scoped=true"
import script from "./checklistCommentsModal.vue?vue&type=script&lang=js"
export * from "./checklistCommentsModal.vue?vue&type=script&lang=js"
import style0 from "./checklistCommentsModal.vue?vue&type=style&index=0&id=294a062f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294a062f",
  null
  
)

export default component.exports